import { useEffect, useState } from 'react';
import axios from 'axios';
import Layout from './components/Layout';
import { API_BASE_URL } from '../config/ApiConfig';
import PaginationBar from './components/PaginationBar';
import TableContainer from './components/TableContainer';
import DataTable from './components/DataTable';
import ResponsiveShadow from './components/ResponsiveShadow';
import useDefaultModal from './components/hooks/useDefaultModal';
import useConfirmModal from './components/hooks/useConfirmModal';
import DefaultModal from './components/modals/DefaultModal';
import ConfirmModal from './components/modals/ConfirmModal';
import NaturezaModal from './components/modals/NaturezaModal';
import usePagination10 from './components/hooks/usePagination10';
import PageHeader from './components/PageHeader';
import PageContent from './components/PageContent';
import Toolbar from './components/Toolbar';
import LoadingModal from './components/modals/LoadingModal';

const emptyForm = { id: '', descricao: '' };

function Naturezas() {
  const token = localStorage.getItem('token');
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [showModal, setShowModal] = useState(false);
  const [selected, setSelected] = useState([]);
  const [atualizar, setAtualizar] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const { setConfirmModal, showConfirmModal } = useConfirmModal();
  const { setPagination } = usePagination10(items.length);
  const displayed = items.slice(setPagination.startIndex, setPagination.startIndex + setPagination.rowsPerPage);

  useEffect(() => {
    setIsLoading(true);
    axios.get(`${API_BASE_URL.NATUREZA}/all`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => {
        setItems(r.data);
      })
      .catch(err => {
        if (err.response && err.response.status !== 200 && err.response.status !== 404) {
          showDefaultModal('error', 'Erro ao carregar naturezas.');
        }
      })
      .finally(() => setIsLoading(false));
  }, [token, atualizar]);

  function handleChange(e) { const { name, value } = e.target; setForm(f => ({ ...f, [name]: value })); }
  function handleNew() { setForm(emptyForm); setShowModal(true); }
  function handleEdit() { if (selected.length !== 1) return; setForm({ ...selected[0] }); setShowModal(true); }

  function handleSave(e) {
    e.preventDefault();
    axios.post(`${API_BASE_URL.NATUREZA}/save`, form, { headers: { Authorization: `Bearer ${token}` } })
      .then(() => {
        setShowModal(false);
        setAtualizar(a => !a);
        setSelected([]); // Limpa seleção após salvar
      })
      .catch(() => showDefaultModal('error', 'Erro ao salvar natureza.'));
  }

  function handleDelete() {
    if (selected.length === 0) return;
    showConfirmModal('delete', () => Promise.all(selected.map(s => axios.delete(`${API_BASE_URL.NATUREZA}/delete/${s.id}`, { headers: { Authorization: `Bearer ${token}` } })))
      .then(() => { setSelected([]); setAtualizar(a => !a); })
      .catch(() => showDefaultModal('error', 'Erro ao excluir natureza.'))
    );
  }

  function toggleSelect(item) {
    setSelected(prev => prev.find(s => s.id === item.id) ? [] : [item]);
  }

  return (
    <Layout>
      <LoadingModal show={isLoading} />
      <ResponsiveShadow>
        <PageHeader title="NATUREZAS" icon="bi-tag" />
        <PageContent>
          <Toolbar onNew={handleNew} onEdit={handleEdit} disableEdit={selected.length !== 1} onDelete={handleDelete} disableDelete={selected.length === 0}>
          </Toolbar>
          <TableContainer isLoading={false}>
                              <DataTable head={<tr>
                  <th style={{ width: '3rem' }}>#</th><th>Código</th><th>Descrição</th>
                </tr>}>
                <tbody>
                  {displayed.map((item, idx) => (
                    <tr key={item.id} className={selected.find(s => s.id === item.id) ? 'table-success' : ''} onClick={() => toggleSelect(item)} style={{ cursor: 'pointer' }}>
                      <td>{setPagination.startIndex + idx + 1}</td><td>{item.id}</td><td>{item.descricao}</td>
                    </tr>
                  ))}
                </tbody>
              </DataTable>
          </TableContainer>
        </PageContent>
        <PaginationBar setPagination={setPagination} />
      </ResponsiveShadow>
      <NaturezaModal show={showModal} onClose={() => setShowModal(false)} onSubmit={handleSave} form={form} handleChange={handleChange} />
      <DefaultModal {...setDefaultModal} />
      <ConfirmModal {...setConfirmModal} />
    </Layout>
  );
}

export default Naturezas;
